import React from 'react'
import  './home.css'
const Home = () => {
  return (
     <section className="home" id="home">
      <div className="container">
        <div className="grid">
          <div className="home-text">
            <h1 data-aos="fade-up" data-aos-duration="1000">Professional Cleaning Services in Melbourne | Sunshine, Werribee, Point Cook & Western Suburbs</h1>
            <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay="150">"We don’t just clean — we care.Let your space sparkle like never before!"</p>
            <div className="btn-wrap" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300">
              <a href="#about" className="btn">know more</a>
            </div>
          </div>
          <div className="home-img">
            <div className="circle-wrap" data-aos="fade-right" data-aos-duration="1000">
              <div className="circle"></div>
            </div>
              <img src="img/home-img.png" alt="Professional cleaning services Melbourne - Niks Elite Cleaning team" loading="lazy" data-aos="fade-left" data-aos-duration="1000" />
          </div>
          
        </div>
      </div>
    </section>
  )
}

export default Home